import { twMerge } from "tailwind-merge";

type IPaginationProps = {
    currentPage: number;
    totalPages: number;
    handleNextPage: () => void;
    handlePreviousPage: () => void;
};

export default function Pagination({ currentPage, handleNextPage, handlePreviousPage, totalPages }: IPaginationProps) {
    return <div className="flex justify-between items-center mt-4">
        <button
            className={twMerge(
                "px-4 py-2 rounded",
                currentPage === 1 ? "bg-gray-300 cursor-not-allowed" : "bg-orange-1000"
            )}
            onClick={handlePreviousPage}
            disabled={currentPage === 1}
        >
            Previous
        </button>
        <span>Page {currentPage} of {totalPages}</span>
        <button
            className={twMerge(
                "px-4 py-2 rounded",
                currentPage === totalPages ? "bg-gray-300 cursor-not-allowed" : "bg-orange-1000"
            )}
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
        >
            Next
        </button>
    </div>
}